import rgba from 'color-rgba';

export type RGBColor = [number, number, number];

// Luma coefficients based on https://en.wikipedia.org/wiki/Rec._709
const LUMA_COEFFICIENTS: [number, number, number] = [0.2126, 0.7152, 0.0722];

export function calculateLuma([r, g, b]: RGBColor) {
  return (
    (LUMA_COEFFICIENTS[0] * r +
      LUMA_COEFFICIENTS[1] * g +
      LUMA_COEFFICIENTS[2] * b) /
    255
  );
}

export function rgbColorToString(color: RGBColor, alpha?: number) {
  return `rgb(${color.join(',')}${alpha != null ? `,${alpha}` : ''})`;
}

const POSSIBLE_HEX_REGEX = /^#?([0-9a-fA-F]{1,6})$/;
const POSSIBLE_INVALID_HEX_REGEX = /#([0-9a-zA-Z]{6})/;

function normalizeHexColorInput(input: string): string {
  const trimmedInput = input.trim();

  if (!POSSIBLE_HEX_REGEX.test(trimmedInput)) {
    const match = trimmedInput.match(POSSIBLE_INVALID_HEX_REGEX);

    if (match?.[1]) {
      // This will normalize 'x#ffffff' to '#FFFFFF'
      // and '#ffxxxx' to '#FF0000'
      return normalizeHexColorInput(
        `#${match[1].replace(/[^0-9a-fA-F]/g, '')}`,
      );
    }

    return trimmedInput;
  }

  let hex = trimmedInput.replace(/^#/, '');
  if (hex.length > 3 && hex.length <= 5) {
    hex = hex.padEnd(6, '0');
  }

  return `#${hex}`;
}

function parseColor(input: string) {
  return rgba(normalizeHexColorInput(input));
}

export function normalizeToHex(input: string) {
  const [r, g, b] = parseColor(input);

  if (r != null && g != null && b != null) {
    const red = Math.round(r).toString(16).padStart(2, '0').toUpperCase();
    const green = Math.round(g).toString(16).padStart(2, '0').toUpperCase();
    const blue = Math.round(b).toString(16).padStart(2, '0').toUpperCase();
    return `#${red}${green}${blue}`;
  }

  return null;
}
